import { graphql } from "react-relay";
export const fragments = {
  org: graphql`
    fragment OnboardingScheduleTestEventStepRenderer_org on Org
    @argumentDefinitions(week: { type: "LocalWeek!" }) {
      id
      primaryOrgCalendar
      experiments
      crawlTest
      primaryOrgEmail
      userWorkingHours(resolveOverrides: false) {
        id
        hasBeenSet
        workingHours {
          id
          type
          timeZone
          daySettings {
            day
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
          dayOverrides {
            date
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
        }
      }
      calculateSmartHoldsErrorable(week: $week) {
        __typename
        ... on SmartHoldCalculationResult {
          events {
            title
            locked
            isClockwiseEvent
            isAllDay
            calendarIds
            organizer {
              urnValue
              responseStatus
            }
            attendees {
              urnValue
              responseStatus
            }
            creator {
              urnValue
            }
            annotatedEvent {
              userTags {
                tag
                states {
                  subjectType
                  subjectValue
                  value
                }
              }
              orgTags {
                tag
                state {
                  subjectType
                  subjectValue
                  value
                }
              }
            }
            eventKey {
              externalEventId
            }
            location
            startTime {
              dateOrDateTime
              millis
            }
            endTime {
              dateOrDateTime
              millis
            }
          }
        }
      }
    }
  `,
  user: graphql`
    fragment OnboardingScheduleTestEventStepRenderer_user on User {
      id
      emails
    }
  `,
};
export const query = graphql`
  query OnboardingScheduleTestEventStepRendererQuery(
    $orgRelayId: ID!
    $query: SchedulingQueryInput!
    $week: LocalWeek!
  ) {
    node(id: $orgRelayId) {
      id
      ...OnboardingScheduleTestEventStepRenderer_org @arguments(week: $week)
      ... on Org {
        schedulingResponseErrorable(query: $query) {
          ... on SchedulingResponse {
            slots {
              summary {
                availableRooms
                freeAttendees
                inconvenientForAttendees
                focusTimeMinutesCost
                conflictingAttendees
                tags
              }
              attendanceImpacts {
                calendarId
                inconveniences
                hasConflict
                focusTimeMinutesCost
                conflictingMeetings
              }
              roomImpacts {
                roomId
                available
              }
              timeRange {
                id
                startTime {
                  type
                  dateOrDateTime
                  timeZone
                  offsetMinutes
                  millis
                }
                endTime {
                  type
                  dateOrDateTime
                  timeZone
                  offsetMinutes
                  millis
                }
              }
            }
          }
          ... on GraphEntityError {
            message
            statusCode
            body
          }
        }
      }
    }
  }
`;
